import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { BrokerMappingService } from '../broker-mapping.service';
import { CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { map } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { DrawerModule } from 'primeng/drawer';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-add-broker-mapping',
    templateUrl: './add-broker-mapping.component.html',
    styleUrls: ['./add-broker-mapping.component.scss'],
    imports: [CommonModule, TableModule, ButtonModule, FormsModule, Select,
        MatProgressSpinnerModule, MatTooltipModule, ConfirmDialogModule, DrawerModule, ToastModule
    ]
})
export class AddBrokerMappingComponent implements OnInit {
  @Input('columns') columns: any;
  constructor(public brokerMappingService: BrokerMappingService,
    private userService: UserService,
    private messageService: MessageService,) { 
    }

  ngOnInit() {
  }

  onSave() {
    this.brokerMappingService.isLoadingResults = true;
    let payload = {
      "mpid": this.userService.getActiveMPID(),
      "firmMPID": this.userService.getActiveMPID(),
      "receivedFromMPID": this.brokerMappingService.addRow['ReceivedFromMPID'],
      "customerID": this.brokerMappingService.addRow['CustomerID'],
      "affiliateFlag": this.brokerMappingService.addRow['AffiliateFlag'],
      "id": this.brokerMappingService.addRow['id'],
      "user": this.userService.getUserName(),
    }
    this.brokerMappingService.getAdd(payload)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (data:any) => {
          this.brokerMappingService.isLoadingResults = false;
            this.brokerMappingService.isAdd = false;
            this.brokerMappingService.reloadData();
          if(data.status){
            this.messageService.add({ severity: 'success', summary: 'Add Record Message', detail: data.data });
          }else{
            this.messageService.add({ severity: 'error', summary: 'Add Record Message', detail: data.data });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.brokerMappingService.isLoadingResults = false;
          this.brokerMappingService.isAdd = false;
        }
      });  
  }

  onClose() {
    this.brokerMappingService.isAdd = false;
  }

  onReset() {

  }

  ngOnDestroy() {
    this.brokerMappingService.isAdd = false;
  }
}